// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import { backPackEventMap } from "../../../config/BackpackEventConfig";
import NormalGameManager from "../../../manager/NormalGameManager";
const {ccclass, property} = cc._decorator;

const g_list = [
    30007,
    10054,
    50001,
    50002,
    50003,
    50004,
    50005,
    50006,
    50007,
    50008,
    50009,
    50010,
    50011,
    50012,
    50013,
    50014,
    50015,
    50018,
    50019,
    50021,
    50022,
    50024,
    50025,
    50026,
    50027,
    50028,
    50029,
    50030,
    50031,
    50032,
    50033,
    50034,
    50035,
    50036,
    50037,
    50038,
    50039,
    50040,
    50041,
    50042,
    50043,
    50044,
    50045,
    50046,
];

const c_maxCount = 3;
@ccclass
export default class SuperPowerSelect5 extends BasePopUpLayer {
   

    @property(cc.Node)
    nodeItem: cc.Node = null;

    @property(cc.Node)
    nodeSelect: cc.Node = null;

    @property(cc.Label)
    labelSelect: cc.Label = null;

    private curSelectCount = 0;
    private goodsList: number[] = [];
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.nodeItem.active = false;

        this.refreshSelectState();
        this.refreshList();
    }

    refreshSelectState() {
        this.labelSelect.string = `选好了(${this.curSelectCount}/${c_maxCount})`;
    }

    refreshList() {
        this.goodsList = [];
        this.curSelectCount = 0;
        this.refreshSelectState();
        this.nodeSelect.removeAllChildren();
        let list = data_control.randomIntNum(0, g_list.length-1, 8);
        for (let i = 0; i < list.length; i++) {
            let goodsId = g_list[list[i]];
            let item = cc.instantiate(this.nodeItem);
            this.nodeSelect.addChild(item);
            item.active = true;

            let itemBtn = item.getComponent(cc.Button);
            itemBtn.clickEvents[0].customEventData = '' + goodsId;
           
            let sprSelect = item.getChildByName('sprSelect');
            sprSelect.active = false;
            let sprGoods = item.getChildByName('sprGoods').getComponent(cc.Sprite);
            let labelName = item.getChildByName('label').getComponent(cc.Label);
            let backItem = backPackEventMap()[goodsId];
            labelName.string = backItem.name;
            utilsView.loadGoodsSpriteFrame(
                sprGoods
                , backItem.spPath
                , false
            );
        }

        // this.nodeSelect.getComponent(cc.Layout).updateLayout();
    }

    onClickConfirm() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        if (this.curSelectCount <= 0) {
            O1HD.getModules().uiControlModule.showMessageBox('请至少选择一个');
            return;
        }

        for (let o of this.goodsList) {
            NormalGameManager._instance.onPushGoods(o, 1, false);
        }
        O1HD.emit("normalMode.updateLieYing");
        this.destroyNode();
        this._carryData.parent.showEndUI('那就这么说定咯，我们下次再会');
    }

    onClickAd() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.refreshList();
        },()=>{
 
        }, null, "广告言出法随换一批神器");
    }
    
    onClickSelect(event: cc.Event.EventTouch, data) {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        let id = Number(data);
        let item = event.getCurrentTarget();
        let sprSelect = item.getChildByName('sprSelect');
        if (sprSelect.active) {
            let idx = this.goodsList.indexOf(id);
            if (idx != -1) {
                this.goodsList.splice(idx, 1);
                this.curSelectCount--;
            }
        } else {
            if (this.curSelectCount >= 3) {
                O1HD.getModules().uiControlModule.showMessageBox('最多只能选择3个');
                return;
            }
            this.goodsList.push(id);
            this.curSelectCount++;
        }
        this.refreshSelectState();
        sprSelect.active = !sprSelect.active;
    }

    // update (dt) {}
}
